import Vue from "vue";
import { Notice,Spin,LoadingBar } from "iview";


export let $success = function(msg) {
    Notice.success({
        title: 'Success',
        render: h => {
            return h('span', [
                msg
            ])
        }
    });
};
Vue.prototype.$success = $success;

export let $warning = function(msg) {
    Notice.warning({
        title: 'Warning',
        render: h => {
            return h('span', [
                msg,
            ])
        }
    });
};
Vue.prototype.$warning = $warning;


export let $error = function(msg) {
    Notice.error({
        title: 'Error',
        render: h => {
            return h('span', [
                msg,
            ])
        }
    });
};
Vue.prototype.$errorMsg = $error;

Vue.prototype.$LoadingBar = LoadingBar;

Vue.prototype.$Spin = Spin;

